var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{'cursor-pointer':_vm.item.deleted_at == null},on:{"dblclick":function($event){return _vm.changeStatus()}}},[_c('span',{staticClass:"status-chip",class:_vm.statusState ? 'is-on' : 'is-off'},[_vm._v(" "+_vm._s(_vm.statusState ? 'منتشر شده' : 'منتشر نشده')+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }